export type CashierPaymentState = {
  status?: string
  statusText?: string
  offlineConfirmedByName?: string
  offlineConfirmedAt?: string
}

export function cashierPaymentOutcome(order: CashierPaymentState) {
  if (order.status === 'PAID') {
    const confirmation = [order.offlineConfirmedByName, order.offlineConfirmedAt].filter(Boolean).join(' · ')
    return { label: '已确认', detail: confirmation || '收款已入账', tone: 'confirmed' }
  }
  if (order.status === 'CANCELLED') {
    return { label: '已取消', detail: '未确认收款', tone: 'cancelled' }
  }
  if (order.status === 'REFUNDED') {
    return { label: '已退款', detail: order.statusText || '款项已退回', tone: 'refunded' }
  }
  return { label: order.statusText || order.status || '状态异常', detail: '未确认收款', tone: 'unconfirmed' }
}
